import { useNavigate } from 'react-router-dom';
import { Alert, Button, Stack } from '@mui/material';

interface ActiveCallElsewhereBannerProps {
  activeEncounterId: string;
  onEndCall: () => void;
}

export function ActiveCallElsewhereBanner({
  activeEncounterId,
  onEndCall,
}: ActiveCallElsewhereBannerProps) {
  const navigate = useNavigate();

  return (
    <Alert
      severity="info"
      sx={{ borderRadius: 2 }}
      action={
        <Stack direction="row" spacing={1}>
          <Button
            size="small"
            variant="contained"
            onClick={() => navigate(`/encounters/${activeEncounterId}`)}
          >
            Return to Call
          </Button>
          <Button size="small" color="error" variant="outlined" onClick={onEndCall}>
            End Call
          </Button>
        </Stack>
      }
    >
      You have an active telehealth call on another encounter.
    </Alert>
  );
}
